/* NEBULIX v5 · Header + Home. Se carga con defer; se ejecuta una sola vez aunque varias secciones lo incluyan. */
(function () {
  if (window.__nxHome) return;
  window.__nxHome = true;
  var doc = document;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = function (cents) { return '$' + Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'); };
  var esc = function (s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* ---------------- HEADER ---------------- */
  function Header(h) {
    /* Anuncios rotativos */
    var msgs = [].slice.call(h.querySelectorAll('.nx-ann__msg')), mi = 0, mt;
    function showMsg(i) { mi = (i + msgs.length) % msgs.length; msgs.forEach(function (m, k) { m.classList.toggle('is-on', k === mi); m.setAttribute('aria-hidden', k === mi ? 'false' : 'true'); }); }
    function playMsg() { clearInterval(mt); if (msgs.length > 1 && !reduce) mt = setInterval(function () { showMsg(mi + 1); }, 4500); }
    if (msgs.length) {
      showMsg(0); playMsg();
      var p = h.querySelector('[data-nx-ann-prev]'), n = h.querySelector('[data-nx-ann-next]');
      if (p) p.addEventListener('click', function () { showMsg(mi - 1); playMsg(); });
      if (n) n.addEventListener('click', function () { showMsg(mi + 1); playMsg(); });
    }

    /* Header compacto al bajar */
    /* Al bajar, el header sube lo que mide la barra negra (top negativo del sticky).
       No cambia el alto de la página, así el header no tiembla. */
    var ann = h.querySelector('.nx-ann'), sec = h.closest('.nx-header-section') || h.parentNode, last = window.scrollY, ticking = false, hidden = false;
    function setHidden(v) {
      if (v === hidden) return;
      hidden = v;
      sec.style.top = v ? (-ann.offsetHeight) + 'px' : '0px';
    }
    function onScroll() {
      var y = window.scrollY, d = y - last;
      h.classList.toggle('is-stuck', y > 10);
      if (ann) {
        if (y <= 160) setHidden(false);
        else if (d > 8) setHidden(true);
        else if (d < -8) setHidden(false);
      }
      if (y <= 160 || Math.abs(d) > 8) last = y;
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

    /* Megamenú */
    var btn = h.querySelector('[data-nx-mega-btn]'), mega = h.querySelector('[data-nx-mega]'), closeT;
    function openMega(o) {
      if (!btn || !mega) return;
      mega.hidden = !o; btn.setAttribute('aria-expanded', o ? 'true' : 'false');
    }
    if (btn && mega) {
      btn.addEventListener('click', function () { openMega(mega.hidden); });
      [btn, mega].forEach(function (el) {
        el.addEventListener('mouseenter', function () { clearTimeout(closeT); if (window.matchMedia('(hover: hover)').matches) openMega(true); });
        el.addEventListener('mouseleave', function () { closeT = setTimeout(function () { openMega(false); }, 220); });
      });
      doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') { openMega(false); btn.focus(); } });
      doc.addEventListener('click', function (e) { if (!h.contains(e.target)) openMega(false); });
    }

    /* Cajón móvil */
    var drawer = h.querySelector('[data-nx-drawer]');
    function drawerOpen(o) {
      if (!drawer) return;
      drawer.classList.toggle('is-open', o);
      drawer.setAttribute('aria-hidden', o ? 'false' : 'true');
      doc.documentElement.style.overflow = o ? 'hidden' : '';
      if (o) { var f = drawer.querySelector('button, a'); if (f) f.focus(); }
    }
    h.querySelectorAll('[data-nx-drawer-open]').forEach(function (b) { b.addEventListener('click', function () { drawerOpen(true); }); });
    h.querySelectorAll('[data-nx-drawer-close]').forEach(function (b) { b.addEventListener('click', function () { drawerOpen(false); }); });
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawerOpen(false); });

    /* Buscador predictivo */
    h.querySelectorAll('[data-nx-search]').forEach(Search);

    /* Carrito: abre el carrito lateral de Nebulix si existe */
    h.querySelectorAll('[data-nx-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (window.NebulixPDP && doc.querySelector('[data-cart-drawer]')) { e.preventDefault(); window.NebulixPDP.openDrawer(); }
      });
    });
  }

  function Search(box) {
    var input = box.querySelector('input[type="search"]');
    var out = box.querySelector('[data-nx-suggest]');
    if (!input || !out) return;
    var t, ctrl, items = [], active = -1;
    var popular = (box.getAttribute('data-popular') || '').split('|').filter(Boolean);
    function close() { out.hidden = true; input.setAttribute('aria-expanded', 'false'); active = -1; }
    function openHTML(html) { out.innerHTML = html; out.hidden = false; input.setAttribute('aria-expanded', 'true'); items = [].slice.call(out.querySelectorAll('.nx-suggest__item')); active = -1; }
    function chips() {
      if (!popular.length) return close();
      openHTML('<p class="nx-suggest__label">Lo más buscado</p><div class="nx-suggest__chips">' + popular.map(function (p) { return '<a href="' + root + 'search?q=' + encodeURIComponent(p) + '">' + esc(p) + '</a>'; }).join('') + '</div>');
    }
    function render(q, data) {
      var r = (data && data.resources && data.resources.results) || {};
      var prods = r.products || [], cols = r.collections || [];
      if (!prods.length && !cols.length) return openHTML('<p class="nx-suggest__empty">No encontramos resultados para “' + esc(q) + '”. Prueba con otra palabra.</p>');
      var html = '';
      if (cols.length) html += '<p class="nx-suggest__label">Categorías</p><div class="nx-suggest__chips">' + cols.slice(0, 4).map(function (c) { return '<a href="' + c.url + '">' + esc(c.title) + '</a>'; }).join('') + '</div>';
      if (prods.length) html += '<p class="nx-suggest__label">Productos</p>' + prods.slice(0, 6).map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
        var price = typeof p.price === 'string' && p.price.indexOf('.') > -1 ? Math.round(parseFloat(p.price) * 100) : +p.price;
        return '<a class="nx-suggest__item" href="' + p.url + '" role="option">' +
          (img ? '<img src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="" width="52" height="52" loading="lazy">' : '<span></span>') +
          '<span class="nx-suggest__t">' + esc(p.title) + '</span><span class="nx-suggest__p">' + (price ? money(price) : '') + '</span></a>';
      }).join('');
      html += '<a class="nx-suggest__all" href="' + root + 'search?q=' + encodeURIComponent(q) + '">Ver todos los resultados para “' + esc(q) + '”</a>';
      openHTML(html);
    }
    function query() {
      var q = input.value.trim();
      if (q.length < 2) return chips();
      if (ctrl) ctrl.abort();
      ctrl = window.AbortController ? new AbortController() : null;
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last';
      (window.NxSuggestMock ? window.NxSuggestMock(q) : fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.json(); }))
        .then(function (d) { render(q, d); }).catch(function () {});
    }
    input.addEventListener('input', function () { clearTimeout(t); t = setTimeout(query, 180); });
    input.addEventListener('focus', function () { if (!input.value.trim()) chips(); else query(); });
    input.addEventListener('keydown', function (e) {
      if (out.hidden || !items.length) { if (e.key === 'Escape') close(); return; }
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        active = (active + (e.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
        items.forEach(function (it, k) { it.classList.toggle('is-active', k === active); });
      } else if (e.key === 'Enter' && active > -1) { e.preventDefault(); location.href = items[active].href; }
      else if (e.key === 'Escape') close();
    });
    doc.addEventListener('click', function (e) { if (!box.contains(e.target)) close(); });
  }

  /* ---------------- BANNERS ---------------- */
  function Slides(el) {
    var s = [].slice.call(el.querySelectorAll('.nx-slide')), dots = [].slice.call(el.querySelectorAll('.nx-slides__dot'));
    if (s.length < 2) return;
    var i = 0, t, hover = false, paused = false;
    var delay = +el.getAttribute('data-delay') || 5000;
    el.style.setProperty('--nx-delay', delay + 'ms');
    function go(k) {
      i = (k + s.length) % s.length;
      s.forEach(function (x, n) { x.classList.toggle('is-on', n === i); });
      dots.forEach(function (d, n) { d.classList.remove('is-on'); if (n === i) { void d.offsetWidth; d.classList.add('is-on'); d.setAttribute('aria-current', 'true'); } else d.removeAttribute('aria-current'); });
    }
    function play() { clearInterval(t); if (!reduce && !paused && !hover && !doc.hidden) t = setInterval(function () { go(i + 1); }, delay); el.classList.toggle('is-paused', paused || hover || reduce); }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); play(); }); });
    var pv = el.querySelector('[data-nx-prev]'), nx = el.querySelector('[data-nx-next]'), pz = el.querySelector('[data-nx-pause]');
    if (pv) pv.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    if (pz) pz.addEventListener('click', function () { paused = !paused; pz.setAttribute('aria-label', paused ? 'Reproducir banners' : 'Pausar banners'); play(); });
    el.addEventListener('mouseenter', function () { hover = true; play(); });
    el.addEventListener('mouseleave', function () { hover = false; play(); });
    doc.addEventListener('visibilitychange', play);
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) { if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; if (Math.abs(dx) > 40) { go(dx < 0 ? i + 1 : i - 1); play(); } x0 = null; });
    go(0); play();
  }

  /* ---------------- Carriles con flechas ---------------- */
  function Rail(sec) {
    var rail = sec.querySelector('[data-nx-rail-track]');
    sec.querySelectorAll('[data-nx-rail]').forEach(function (b) {
      b.addEventListener('click', function () { if (rail) rail.scrollBy({ left: (b.getAttribute('data-nx-rail') === 'next' ? 1 : -1) * rail.clientWidth * .8, behavior: reduce ? 'auto' : 'smooth' }); });
    });
  }

  /* ---------------- Rotación automática de carruseles ----------------
     Avanza una tarjeta cada X ms solo si el carrusel se puede deslizar (en desktop las
     grillas no rotan), está en pantalla y el cliente no lo está tocando. Al final vuelve al inicio. */
  function AutoRail(el) {
    if (reduce) return;
    var delay = +el.getAttribute('data-nx-auto') || 4000, t, seen = false, hold = false, resume;
    function step() {
      if (!el.offsetParent || el.scrollWidth - el.clientWidth < 8) return;
      var first = el.firstElementChild; if (!first) return;
      var gap = parseFloat(getComputedStyle(el).columnGap) || 0;
      var w = first.getBoundingClientRect().width + gap;
      var end = el.scrollLeft + el.clientWidth >= el.scrollWidth - 8;
      var from = el.scrollLeft, to = end ? 0 : Math.min(from + w, el.scrollWidth - el.clientWidth);
      el.scrollTo({ left: to, behavior: 'smooth' });
      /* Respaldo: si el navegador no animó el desplazamiento, salta directo a la siguiente tarjeta. */
      setTimeout(function () { if (Math.abs(el.scrollLeft - from) < 2) el.scrollLeft = to; }, 900);
    }
    function play() { clearInterval(t); if (seen && !hold && !doc.hidden) t = setInterval(step, delay); }
    function pause() { hold = true; clearTimeout(resume); play(); }
    function later() { clearTimeout(resume); resume = setTimeout(function () { hold = false; play(); }, 6000); }
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', later, { passive: true });
    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', function () { hold = false; play(); });
    el.addEventListener('focusin', pause);
    el.addEventListener('focusout', later);
    var sec = el.closest('[data-nx-rail-sec]');
    if (sec) sec.querySelectorAll('[data-nx-rail]').forEach(function (b) { b.addEventListener('click', function () { pause(); later(); }); });
    doc.addEventListener('visibilitychange', play);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { seen = es[0].isIntersecting; play(); }, { threshold: .4 }).observe(el);
    } else { seen = true; play(); }
  }

  /* ---------------- Pestañas (productos y pagos) ---------------- */
  function Tabs(sec) {
    var tabs = [].slice.call(sec.querySelectorAll('[role="tab"]'));
    function sel(k, focus) {
      tabs.forEach(function (t, n) {
        var on = n === k;
        t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
        var p = doc.getElementById(t.getAttribute('aria-controls')); if (p) p.hidden = !on;
      });
      if (focus) tabs[k].focus();
    }
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { sel(n); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { e.preventDefault(); sel((n + 1) % tabs.length, true); }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { e.preventDefault(); sel((n - 1 + tabs.length) % tabs.length, true); }
      });
    });
  }

  /* ---------------- Cuenta regresiva ---------------- */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  /* Fin del ciclo actual: inicio + N ciclos completos de X días. Al terminar, pasa solo al siguiente. */
  function cycleEnd(start, days) {
    var period = days * 86400000, now = Date.now();
    if (now < start) return start + period;
    return start + (Math.floor((now - start) / period) + 1) * period;
  }
  function Count(el) {
    var cStart = Date.parse(el.getAttribute('data-cycle-start') || '');
    var cDays = parseInt(el.getAttribute('data-cycle-days'), 10) || 0;
    var cycle = !isNaN(cStart) && cDays > 0;
    var end = cycle ? cycleEnd(cStart, cDays) : Date.parse(el.getAttribute('data-end'));
    if (isNaN(end)) { el.hidden = true; return; }
    (function tick() {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0 && cycle) { end = cycleEnd(cStart, cDays); s = Math.floor((end - Date.now()) / 1000); }
      if (s <= 0) { el.hidden = true; return; }
      el.hidden = false;
      var d = Math.floor(s / 86400); s -= d * 86400; var h = Math.floor(s / 3600); s -= h * 3600; var m = Math.floor(s / 60); s -= m * 60;
      var set = function (k, v) { var b = el.querySelector('[data-u="' + k + '"]'); if (b) b.textContent = pad(v); };
      set('d', d); set('h', h); set('m', m); set('s', s);
      var du = el.querySelector('[data-u="d"]'); if (du) du.parentNode.hidden = d === 0;
      setTimeout(tick, 1000);
    })();
  }

  /* ---------------- Galería destacado ---------------- */
  doc.addEventListener('click', function (e) {
    var t = e.target.closest('[data-nx-thumb]'); if (!t) return;
    var w = t.closest('[data-nx-spot]'), main = w && w.querySelector('[data-nx-spot-main] img'); if (!main) return;
    main.src = t.getAttribute('data-src'); main.removeAttribute('srcset');
    w.querySelectorAll('[data-nx-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
  });

  /* ---------------- Carrito + GA4 ---------------- */
  function push(ev, data) { if (!window.dataLayer) return; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: ev, ecommerce: data }); }
  function item(el) { return { item_id: el.getAttribute('data-item-id'), item_name: el.getAttribute('data-item-name'), price: parseFloat(el.getAttribute('data-item-price')) || undefined, index: parseInt(el.getAttribute('data-item-index'), 10) || undefined }; }
  doc.addEventListener('click', function (e) {
    var a = e.target.closest('a'); if (!a) return;
    var it = a.closest('[data-nx-item]'); if (!it) return;
    var l = it.closest('[data-nx-list]');
    push('select_item', { item_list_name: l ? l.getAttribute('data-nx-list') : 'Home', items: [item(it)] });
  });
  function setCount(n) {
    doc.querySelectorAll('[data-nx-cart-count]').forEach(function (b) { b.textContent = n; b.setAttribute('data-count', n); b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
    doc.querySelectorAll('[data-neb-cart-count], .cart-count-bubble span[aria-hidden="true"]').forEach(function (b) { b.textContent = n; });
  }
  var toast;
  function showToast(it) {
    if (!toast) { toast = doc.createElement('div'); toast.className = 'nx nx-toast'; toast.setAttribute('role', 'status'); doc.body.appendChild(toast); }
    toast.innerHTML = (it.image ? '<img src="' + it.image + '" alt="" width="50" height="50">' : '<span></span>') +
      '<div style="min-width:0"><p class="nx-toast__t">✓ Agregado al carrito</p><p class="nx-toast__n">' + esc(it.product_title) + '</p></div>' +
      '<a class="nx-btn nx-btn--green nx-btn--sm" href="' + root + 'cart">Ver carrito</a>';
    toast.classList.add('is-on'); clearTimeout(toast._t); toast._t = setTimeout(function () { toast.classList.remove('is-on'); }, 5000);
  }
  doc.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-nx-add]'); if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]'); if (btn.classList.contains('is-loading')) return;
    var lab = btn.querySelector('[data-nx-label]'), orig = lab ? lab.textContent : '';
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function (it) {
        push('add_to_cart', { currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'COP', value: it.final_line_price / 100, items: [{ item_id: String(it.product_id), item_name: it.product_title, price: it.final_price / 100, quantity: it.quantity || 1 }] });
        doc.dispatchEvent(new CustomEvent('nebulix:cart:added', { detail: it }));
        btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); btn.classList.add('is-added'); if (lab) lab.textContent = 'Agregado';
        fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {});
        if (window.NebulixPDP && doc.querySelector('[data-cart-drawer]')) window.NebulixPDP.openDrawer(); else showToast(it);
        setTimeout(function () { btn.classList.remove('is-added'); if (lab) lab.textContent = orig; }, 2400);
      })
      .catch(function () { form.submit(); });
  });

  /* ---------------- Arranque ---------------- */
  function boot(scope) {
    scope = scope || doc;
    var once = function (sel, fn) { var k = '__nx' + sel; scope.querySelectorAll(sel).forEach(function (el) { if (el[k]) return; el[k] = 1; fn(el); }); };
    once('[data-nx-header]', Header);
    once('[data-nx-slides]', Slides);
    once('[data-nx-rail-sec]', Rail);
    once('[data-nx-tabs]', Tabs);
    once('[data-nx-count]', Count);
    once('[data-nx-auto]', AutoRail);
    if ('IntersectionObserver' in window) once('[data-nx-list]', function (l) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (en) { if (!en.isIntersecting) return; io.disconnect(); push('view_item_list', { item_list_name: l.getAttribute('data-nx-list'), items: [].map.call(l.querySelectorAll('[data-nx-item]'), item) }); }); }, { threshold: .3 });
      io.observe(l);
    });
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  doc.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
